import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import SpacingGrid from './SpacingGrid';
import ClientProvider from './client';
export default createDemo(import.meta.url, SpacingGrid, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/system/components/grid/demos/spacing/SpacingGrid.tsx",
    "fileName": "SpacingGrid.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport Grid from '@mui/system/Grid';\nimport FormLabel from '@mui/material/FormLabel';\nimport FormControl from '@mui/material/FormControl';\nimport FormControlLabel from '@mui/material/FormControlLabel';\nimport RadioGroup from '@mui/material/RadioGroup';\nimport Radio from '@mui/material/Radio';\nimport Paper from '@mui/material/Paper';\nimport { HighlightedCode } from '@mui/internal-core-docs/HighlightedCode';\n\nexport default function SpacingGrid() {\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 0,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  const [spacing, setSpacing] = React.useState(2);\n\n  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {\n    setSpacing(Number((event.target as HTMLInputElement).value));\n  };\n\n  const jsx = `\n<Grid container spacing={${spacing}}>\n`;\n\n  return (\n    <Grid sx={{ flexGrow: 1 }} container spacing={2}>\n      <Grid size={12}>\n        <Grid container spacing={spacing} sx={{ justifyContent: 'center' }}>\n          {[0, 1, 2].map((value) => (\n            <Grid key={value}>\n              <Paper\n                sx={(theme) => ({\n                  height: 140,\n                  width: 100,\n                  backgroundColor: '#fff',\n                  ...theme.applyStyles('dark', {\n                    backgroundColor: '#1A2027',\n                  }),\n                })}\n              />\n            </Grid>\n          ))}\n        </Grid>\n      </Grid>\n      <Grid size={12}>\n        <Paper sx={{ p: 2 }}>\n          <Grid container>\n            <Grid>\n              <FormControl component=\"fieldset\">\n                <FormLabel component=\"legend\">spacing</FormLabel>\n                <RadioGroup\n                  name=\"spacing\"\n                  aria-label=\"spacing\"\n                  value={spacing.toString()}\n                  onChange={handleChange}\n                  row\n                >\n                  {[0, 0.5, 1, 2, 3, 4, 8, 12].map((value) => (\n                    <FormControlLabel\n                      key={value}\n                      value={value.toString()}\n                      control={<Radio />}\n                      label={value.toString()}\n                    />\n                  ))}\n                </RadioGroup>\n              </FormControl>\n            </Grid>\n          </Grid>\n        </Paper>\n        <HighlightedCode code={jsx} language=\"jsx\" />\n      </Grid>\n    </Grid>\n  );\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 72,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport Grid from '@mui/system/Grid';\nimport FormLabel from '@mui/material/FormLabel';\nimport FormControl from '@mui/material/FormControl';\nimport FormControlLabel from '@mui/material/FormControlLabel';\nimport RadioGroup from '@mui/material/RadioGroup';\nimport Radio from '@mui/material/Radio';\nimport Paper from '@mui/material/Paper';\nimport { HighlightedCode } from '@mui/internal-core-docs/HighlightedCode';\n\nexport default function SpacingGrid() {\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 0
        },
        "  const [spacing, setSpacing] = React.useState(2);\n\n  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {\n    setSpacing(Number((event.target as HTMLInputElement).value));\n  };\n\n  const jsx = `\n<Grid container spacing={${spacing}}>\n`;\n\n  return (\n    <Grid sx={{ flexGrow: 1 }} container spacing={2}>\n      <Grid size={12}>\n        <Grid container spacing={spacing} sx={{ justifyContent: 'center' }}>\n          {[0, 1, 2].map((value) => (\n            <Grid key={value}>\n              <Paper\n                sx={(theme) => ({\n                  height: 140,\n                  width: 100,\n                  backgroundColor: '#fff',\n                  ...theme.applyStyles('dark', {\n                    backgroundColor: '#1A2027',\n                  }),\n                })}\n              />\n            </Grid>\n          ))}\n        </Grid>\n      </Grid>\n      <Grid size={12}>\n        <Paper sx={{ p: 2 }}>\n          <Grid container>\n            <Grid>\n              <FormControl component=\"fieldset\">\n                <FormLabel component=\"legend\">spacing</FormLabel>\n                <RadioGroup\n                  name=\"spacing\"\n                  aria-label=\"spacing\"\n                  value={spacing.toString()}\n                  onChange={handleChange}\n                  row\n                >\n                  {[0, 0.5, 1, 2, 3, 4, 8, 12].map((value) => (\n                    <FormControlLabel\n                      key={value}\n                      value={value.toString()}\n                      control={<Radio />}\n                      label={value.toString()}\n                    />\n                  ))}\n                </RadioGroup>\n              </FormControl>\n            </Grid>\n          </Grid>\n        </Paper>\n        <HighlightedCode code={jsx} language=\"jsx\" />\n      </Grid>\n    </Grid>\n  );\n"
      ],
      [
        "span",
        "frame",
        "}\n"
      ]
    ],
    "totalLines": 72,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/system/Grid",
      "@mui/material/FormLabel",
      "@mui/material/FormControl",
      "@mui/material/FormControlLabel",
      "@mui/material/RadioGroup",
      "@mui/material/Radio",
      "@mui/material/Paper",
      "@mui/internal-core-docs/HighlightedCode"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
